var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "notice-container",
    [
      _c(
        "modal-confirm",
        {
          attrs: {
            confirmLabel: _vm.modalConfirm.confirm,
            cancelLabel: _vm.modalConfirm.cancel,
            title: _vm.modalConfirm.title
          },
          on: {
            confirm: _vm.modalConfirm.resolve,
            canceled: _vm.modalConfirm.reject
          },
          model: {
            value: _vm.modalConfirm.check,
            callback: function($$v) {
              _vm.$set(_vm.modalConfirm, "check", $$v)
            },
            expression: "modalConfirm.check"
          }
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.modalConfirm.message) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "modal-alert",
        {
          attrs: {
            okayLabel: _vm.modalAlert.okay,
            title: _vm.modalAlert.title
          },
          model: {
            value: _vm.modalAlert.check,
            callback: function($$v) {
              _vm.$set(_vm.modalAlert, "check", $$v)
            },
            expression: "modalAlert.check"
          }
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.modalAlert.message) } })]
      ),
      _vm._v(" "),
      _c("toast", { ref: "toast" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }